/**
 * 서버 사이드 장바구니 API
 *
 * 인증된 사용자 전용 서버 장바구니 관리 API
 * 비인증 사용자는 클라이언트 사이드 sessionStorage 장바구니 사용
 *
 * @see olulo-mx-admin/routes/customer-api.php:158-184
 * @see olulo-mx-admin/app/Http/Controllers/Api/V1/CartController.php
 */
import { apiClient } from './client';
import type {
  ServerCart,
  AddCartItemRequest,
  UpdateCartItemRequest,
} from './types';

interface CartResponse {
  data: ServerCart;
}

interface ClearCartResponse {
  success: boolean;
}

export const cartApi = {
  /**
   * 장바구니 조회
   * GET /api/v1/stores/{storeId}/cart
   */
  getCart: (storeId: number): Promise<CartResponse> =>
    apiClient.get<CartResponse>(`/api/v1/stores/${storeId}/cart`),

  /**
   * 장바구니에 아이템 추가
   * POST /api/v1/stores/{storeId}/cart/items
   */
  addItem: (storeId: number, data: AddCartItemRequest): Promise<CartResponse> =>
    apiClient.post<CartResponse>(`/api/v1/stores/${storeId}/cart/items`, data),

  /**
   * 장바구니 아이템 수정 (수량, 옵션 등)
   * PATCH /api/v1/stores/{storeId}/cart/items/{cartItemId}
   */
  updateItem: (storeId: number, cartItemId: number, data: UpdateCartItemRequest): Promise<CartResponse> =>
    apiClient.patch<CartResponse>(`/api/v1/stores/${storeId}/cart/items/${cartItemId}`, data),

  /**
   * 장바구니 아이템 삭제
   * DELETE /api/v1/stores/{storeId}/cart/items/{cartItemId}
   */
  removeItem: (storeId: number, cartItemId: number): Promise<CartResponse> =>
    apiClient.delete<CartResponse>(`/api/v1/stores/${storeId}/cart/items/${cartItemId}`),

  /**
   * 장바구니 전체 비우기
   * DELETE /api/v1/stores/{storeId}/cart
   */
  clearCart: (storeId: number): Promise<ClearCartResponse> =>
    apiClient.delete<ClearCartResponse>(`/api/v1/stores/${storeId}/cart`),
};
